import axios from 'axios'

export const searchApi = axios.create({
  baseURL: process.env.VUE_APP_API_SEARCH_BASE_URL,
})

export const searchGoodsMap = (q, limit) => searchApi.get('/goods', { params: { q, limit } })
export const searchPlace = (q, locale, limit) => searchApi.get('/cities', { params: { q, limit, locale } })
export const searchAteco = (q, limit) => searchApi.get('/ateco', { params: { q, limit } })
